"use client";
import { Button } from "@/components/ui/button";
import { Link, usePathname } from "@/i18n/navigation";

type PropsType = {
  label: string;
  href: string;
};
function NavigationButton({ label, href }: PropsType) {
  const pathName = usePathname();
  return (
    <Button
      asChild
      variant={"secondary"}
      className={`rounded-full border border-muted-foregroun/20 ${pathName === href && "border-primary bg-primary text-background"} text-sm font-400 hover:bg-primary`}
      size={"link"}
    >
      <Link href={href} scroll={false}>
        {label}
      </Link>
    </Button>
  );
}

export default NavigationButton;
